// Asset names are not unique, so always key on id.
export type CreatedAsset = {
  id: string;
  name: string;
};

// sfid is set only for assets that exist in Salesforce.
export type RoomAssetLink = CreatedAsset & {
  sfid?: string;
};

export type UpliftType = 'property_net' | 'bundled_experience' | 'combined';

// Snapshot at attach time, so reporting survives the source experience changing or disappearing.
export type AttachedExperience = {
  id: string;
  dealOptionName: string;
  ancillarySellPriceUplift: number;
  valueCostCurrency: number;
  currency: string;
  costAud: number;
};

export const roomVariantKey = (room: Pick<CategoryRoom, 'assetId' | 'suffix'>) =>
  `${room.assetId}::${room.suffix ?? ''}`;

export const roomDisplayName = ({ assetName, suffix }: Pick<CategoryRoom, 'assetName' | 'suffix'>) =>
  suffix ? `${assetName} - ${suffix}` : assetName;

export type PackageOptionId = string;

export type CategoryRoom = {
  id: PackageOptionId;
  assetId: string;
  assetName: string;
  asiaOnly: boolean;
  suffix?: string;
  upliftType?: UpliftType;
  experiences?: Array<AttachedExperience>;
  propertyNetLift?: number;
};

export type RoomPricing = {
  allocation: string;
  occupancy: string;
  sellByLos: Record<number, string>;
  sellEditedByLos: Record<number, boolean>;
  netByLos: Record<number, string>;
  extraNightSell: string;
  extraNightSellEdited: boolean;
  extraNightNet: string;
  otaPrice: string;
  netPercent?: number;
};

export type NetRateFormulaState = {
  netPercent: string;
  applyToExtraNight: boolean;
  scope: 'all' | 'choose';
  selectedRoomIds: Array<PackageOptionId>;
};

export type OptionState = {
  lengthsOfStay: Array<number>;
  roomsByCategory: Array<Array<CategoryRoom>>;
  selectedLos: number;
  pricingByRoomId: Record<PackageOptionId, RoomPricing>;
  netRateFormula: NetRateFormulaState;
};

export type PackageOptionsDraft = {
  optionStates: Record<number, OptionState>;
  roomAssets: Array<CreatedAsset>;
};
